import formatDegree from './formatDegree';

export default {
  formatDegree,
};



// WEBPACK FOOTER //
// ./src/filters/index.js